import React from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import { HERO_DESCRIPTION, HERO_EYEBROW, TAGLINE } from '../constants/site';
import './HomeHero.css';

const HERO_SLIDES = [
  { src: '/images/content image/img49.jpg', alt: 'Road marking project in Vientiane' },
  { src: '/images/content image/img50.jpeg', alt: 'Traffic safety installation' },
  { src: '/images/content image/img51.jpg', alt: 'Highway signage project' },
  { src: '/images/content image/img52.jpg', alt: 'Road safety equipment' },
  { src: '/images/content image/img21.jpg', alt: 'Road paint repair work' },
];

const HomeHero = () => (
  <section className="home-hero">
    <Carousel
      className="home-hero__carousel"
      interval={5000}
      pause="hover"
      indicators
      controls
    >
      {HERO_SLIDES.map(({ src, alt }) => (
        <Carousel.Item key={src}>
          <img className="home-hero__image" src={src} alt={alt} />
        </Carousel.Item>
      ))}
    </Carousel>

    <div className="home-hero__overlay" aria-hidden="true" />

    <div className="home-hero__content">
      <div className="home-hero__inner">
        <span className="home-hero__eyebrow">{HERO_EYEBROW}</span>
        <h1 className="home-hero__title">{TAGLINE}</h1>
        <p className="home-hero__description">{HERO_DESCRIPTION}</p>
        <div className="home-hero__actions">
          <Link to="/solutions" className="home-hero__btn home-hero__btn--primary">
            Explore solutions
          </Link>
          <Link to="/contact" className="home-hero__btn home-hero__btn--ghost">
            Contact us
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default HomeHero;
